import React, { Component } from 'react';
import {
  Modal,
  Panel,
  Button,
  Table
}                              from "react-bootstrap";
import JSONPretty from 'react-json-pretty';
import moment from 'moment';

import CrudComponent           from "../zynappse-crud";
import schema from "./MemberDetailLog_schema.js";
import { IS_VALID } from 'utils';

class MemberDetailLog extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showModal: false,
      selectedData: null
    };
  }

  render () {
    const {
      showModal,
      selectedData
    } = this.state;

    const crudProps = {
      schema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      customView: (item) => {
        this.setState({
          showModal: true,
          selectedData: item
        });
      }
    };
    
    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>MemberDetailLog</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
            show={showModal}
            onHide={() => {
              this.setState({
                showModal: false,
                selectedData: null
              });
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>VIEW</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <View
                {...{
                  selectedData
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                  onClick={() => {
                    this.setState({
                      showModal: false,
                      selectedData: null
                  });
                }}
              >
                CLOSE
              </Button>
            </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

class View extends Component {
  render () {
    const {
      selectedData
    } = this.props;''

    const GET_VALUE = (key) => {
      if (
          IS_VALID(selectedData) &&
          IS_VALID(selectedData.get(key))
      ) {
          let value = "";

          if (
              key === "createdAt" ||
              key === "updatedAt"
          ) {
              value = moment(selectedData.get(key)).format("MM/DD/YYYY hh:mm:ss A");
          } else if (key === "createMemberDetail_errorData" || key === "setPersonContactID_errorData") {
              value = selectedData.get(key) ? <JSONPretty id={key} data={selectedData.get(key) }/> : ''
          } else if (
            key === 'isFresh' ||
            key === 'setRMALFlag'
          ) {
            if (IS_VALID(selectedData.get(key))) {
              value = selectedData.get(key).toString().toUpperCase();
            }
          } else {
              value = selectedData.get(key);
          }

          return value;
      } else {
          return "";
      }
    }

    let data = [
      {
        label: "memberId",
        value: GET_VALUE("memberId")
      },
      {
        label: "isFresh",
        value: GET_VALUE("isFresh")
      },
      {
        label: "from",
        value: GET_VALUE("from")
      },
      {
        label: "createMemberDetail_status",
        value: GET_VALUE("createMemberDetail_status")
      },
      {
        label: "createMemberDetail_errorData Data",
        value: GET_VALUE("createMemberDetail_errorData")
      },
      {
        label: "setPersonContactID_status",
        value: GET_VALUE('setPersonContactID_status')
      },
      {
        label: "setPersonContactID_errorData",
        value: GET_VALUE('setPersonContactID_errorData')
      },
      {
        label: "setRMALFlag",
        value: GET_VALUE('setRMALFlag')
      },
      {
        label: "setRMALFlag_status",
        value: GET_VALUE('setRMALFlag_status')
      },
      {
        label: "Date",
        value: GET_VALUE('createdAt')
      }
    ];

    return (
      <Table
        bordered
        responsive
      >
        <tbody>
          {data.map((item, index) => (
            <tr id={index}>
              <td>
                <b>{item.label}</b>
              </td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}
export default MemberDetailLog;


// WEBPACK FOOTER //
// ./components/Logs/MemberDetailLog.js